import React from "react";

function NotFound() {
  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h1>Error 404</h1>
      <p>Acceso denegado o página no encontrada</p>
    </div>
  );
}

export default NotFound;